import * as React from 'react';
import styled from 'styled-components';
import {CourseObject} from 'api/course';
import {FileObject, FileType, getFilePath} from 'api/library';
import {useFormikContext} from 'formik';
import Row from 'components/Row';
import Column from 'components/Column';
import {Container as PreviewContainer} from 'components/PreviewPicker';
import Upload, {UploadVariant} from 'components/Upload';
import FormContainer from '../../containers/FormContainer';
import ControlButton from '../../../../ControlButton';
import {IconTrash} from '../../../../../icons';
import VideoPlayer from '../../../../VideoPlayer';
import {LoadedContainer} from '../../../../../containers/LoadedContainer';

const Container = styled.div`
  gap: 20px;
  grid-template-columns: 180px 1fr;
  display: grid;
  
  ${PreviewContainer} {
    grid-row: span 2;
    height: 100%;
  }
`;

/**
 * The video message form part of landing
 * @return {React.ReactElement}
 * @constructor
 */
export default function VideoMessageForm(): React.ReactElement {
  const formContext = useFormikContext<Partial<CourseObject>>();

  /**
   * Render content
   * @return {JSX.Element}
   */
  function renderContent(): JSX.Element {
    /**
     * Set preview and save shape.
     * @param {FileObject} attached
     */
    function setPreview(attached: FileObject): void {
      formContext.setFieldValue('videoMessage.preview', {
        id: attached.id,
        type: attached.type,
        uri: attached.uri,
      });
      formContext.submitForm();
    }

    /**
     * The file select event handler.
     * @param {FileObject[]} attached
     */
    function handleSelect(attached: FileObject[]): void {
      setPreview(attached[0]);
    }

    /**
     * The file upload event handler.
     * @param {FileObject} file
     */
    function handleUpload(file: FileObject): void {
      setPreview(file);
    }

    function handleRemove(): void {
      formContext.setFieldValue('videoMessage.preview', undefined);
      formContext.submitForm();
    }

    return (
      <Row>
        <Column>
          {formContext.values.videoMessage?.preview ? (
            <LoadedContainer controls={(
              <ControlButton onClick={() => handleRemove()}>
                <IconTrash />
              </ControlButton>
            )}>
              <VideoPlayer
                src={getFilePath(formContext.values.videoMessage?.preview.id)}
              />
            </LoadedContainer>
          ) : (
            <Upload
              tabbarProps={{
                param: 'pickerId'
              }}
              type={FileType.Video}
              variant={UploadVariant.Accent}
              picker={{
                onSelect: handleSelect,
              }}
              onUpload={handleUpload}
            />
          )}
        </Column>
      </Row>
    );
  }
  return (
    <FormContainer property="videoMessage" label="Видео-обращение" collapse>
      {renderContent()}
    </FormContainer>
  );
}
